<style lang="scss" scoped>
.contianer {
	width: 100%;
	height: 1190px;
	box-sizing: border-box;
	text-align: center;
}
.impression-title {
	margin-top: 160px;
	margin-bottom: 30px;
}
.more-experirence-content {
	position: relative;
	width: 1297px;
	height: 867px;
	margin: 0 auto;
	background: url('../../assets/pc/more-experirence-content-bg.png');
	padding-top: 55px;
  	box-sizing: border-box;
	.more-experirence-icon1 {
		position: absolute;
		right: -233px;
    	top: 280px;
	}
	.more-experirence-icon2 {
		position: absolute;
		right: -110px;
    	bottom: 195px;
	}
	.more-experirence-icon3 {
		position: absolute;
		left: -112px;
    	top: -17px;
	}
	.more-experirence-icon4 {
		position: absolute;
		left: -152px;
    	bottom: 232px;
	}
}
.switch-items {
	width: 100%;
	height: 75px;
	line-height: 75px;
	padding-left: 90px;
	box-sizing: border-box;
	margin-bottom: 20px;
	.switch-item {
		float: left;
		padding-left: 23px;
		padding-right: 20px;
		letter-spacing: 3px;
		color: #ffeeca;
		font-size: 34px;
		cursor: pointer;
		&:hover {
			color: #bd4f67;
			background: #fad2da;
		}
	}
	.switch-item-choose {
		color: #bd4f67;
		background: #fad2da;
	}
}
.images-block,
.video-block {
	position: absolute;
  	left: 20px;
	width: 1236px;
	height: 675px;
	overflow: auto;
	display: flex;
	justify-content: space-between;
	align-content: space-between;
	flex-wrap: wrap;
	flex-shrink: 0;
	.image-item {
		position: relative;
		width: 610px;
		height: 330px;
		background: url('../../assets/pc/impression-picture-bg.png') no-repeat;
		background-size: 610px 330px;
		cursor: pointer;
		overflow: hidden;
		padding: 1px 2px 2px 2px;
    	box-sizing: border-box;
		.image-item {
			width: 100%;
			height: 100%;
		}
		.video-btn {
			position: absolute;
			top: 88px;
			left: 0;
			right: 0;
			margin: 0 auto;
		}
	}
}
.go-page {
	position: absolute;
	bottom: 5px;
	width: 100%;
	height: 33px;
	text-align: right;
	padding-right: 150px;
  	box-sizing: border-box;
	.go-page-btn {
		margin-left: 80px;
		cursor: pointer;
	}
}
.look-detail {
	position: fixed;
	z-index: 101;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background: rgba(1, 1, 1, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
}
</style>

<template>
	<div class="p-impression pc-common-bg">
		<div class="contianer">
			<img class="impression-title" src="../../assets/pc/impression-title.png" alt="">
			<div class="more-experirence-content">
				<img class="more-experirence-icon1" src="../../assets/pc/more-experirence-icon1.png" alt="">
				<img class="more-experirence-icon2" src="../../assets/pc/more-experirence-icon2.png" alt="">
				<img class="more-experirence-icon3" src="../../assets/pc/more-experirence-icon3.png" alt="">
				<img class="more-experirence-icon4" src="../../assets/pc/more-experirence-icon4.png" alt="">
				<div class="switch-items">
					<div 
						v-for="item in switchItemList" 
						:key="item.id" 
						:class="{'switch-item-choose': itemChoose == item.id}" 
						@click="chooseItem(item.id)" 
						class="switch-item"
					>{{item.name}}</div>
				</div>
				<!-- 图片 -->
				<div v-show="itemChoose == 1" class="images-block">
					<div v-for="item in imagesList" :key="item.ifId" class="image-item">
						<img class="image-item" @click="showImage(item.filePath)"  :src="item.filePath" :alt="item.fileName">
					</div>
				</div>
				<!-- 视频 -->
				<div v-show="itemChoose == 2" class="video-block">
					<div v-for="(item, index) in videoList" :key="index" class="image-item">
						<img class="image-item" :src="item.vlVideoImagePath" :alt="item.vlVideoImageName">
						<img @click="showVideo(item.vlVideoPath)" class="video-btn" src="../../assets/pc/video-btn.png" alt="">
					</div>
				</div>
				<div class="go-page">
					<img @click="goPreview" class="go-page-btn" src="../../assets/pc/preview-page.png" alt="">
					<img @click="goNext" class="go-page-btn" src="../../assets/pc/next-page.png" alt="">
				</div>
			</div>
		</div>
		<p-footer></p-footer>
		<!-- 查看图片及视频 -->
		<div v-show="lookDetailShow" @click="hide" class="look-detail">
			<img v-show="itemChoose == 1" :src="imagePath" alt="">
			<video id="video" v-show="itemChoose == 2" :src="videoPath"></video>
		</div>
	</div>
</template>

<script>
import Footer from '../../components/Footer'
export default {
	name: 'p-more-experirence',
	components: {
		'p-footer': Footer
	},
	data() {
		return {
			switchItemList: [
				{name: '唯美插画', id: 1},
				{name: '声色绘影', id: 2}
			],
			postData: {
				page: 1,
				pageSize: 4,
				platform: "1"
			},
			pageNumber: 1,
			itemChoose: 1,
			imagesList: [],
			videoList: [],
			lookDetailShow: false,
			imagePath: '',
			videoPath: ''
		}
	},
	mounted() {
		const width = document.body.clientWidth;
		if(width < 850) {
			this.$router.push({name: 'm-impression'});
		} else {
			this.getList();
		}
	},
	methods: {
		getList() {
			if(this.itemChoose == 1) {
				this.$http.post('/api/website/getIkonLibraryList', this.postData).then((rsp) => {
					this.imagesList = rsp.result.ikonLibraryList.list;
					this.pageNumber = rsp.result.ikonLibraryList.pages;
				});
			} else {
				this.$http.post('/api/website/getVideoLibraryList', this.postData).then((rsp) => {
					this.videoList = rsp.result.videoLibraryList.list;
					this.pageNumber = rsp.result.videoLibraryList.pages;
				});
			}
		},
		chooseItem(id) {
			this.itemChoose = id;
			this.postData.page = 1;
			this.getList();
		},
		goNext() {
			if(this.postData.page < this.pageNumber) {
				this.postData.page++;
				this.getList();
			} else {
				this.$Message.warning('没有更多了哦');
			}
		},
		goPreview() {
			if(this.postData.page != 1) {
				this.postData.page--;
				this.getList();
			} else {
				this.$Message.warning('没有上一页哦');
			}
		},
		showImage(path) {
			this.lookDetailShow = true;
			this.imagePath = path;
		},
		showVideo(path) {
			this.lookDetailShow = true;
			this.videoPath = path;
			this.$nextTick(() => {
				document.getElementById("video").play();
			});
		},
		hide() {
			this.lookDetailShow = !this.lookDetailShow;
			document.getElementById("video").pause();
		}
	}
}
</script>